module.exports = __webpack_public_path__ + "assets/06d3f655e1410034c49bc0993f5033f2.png";